var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportarrow3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.76329,-7.46798)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-336.228,-249.021)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.77329,-2.87702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.228,261.376L343.228,261.376C340.469,261.376 338.228,263.617 338.228,266.376L338.228,306.376C338.228,309.136 340.469,311.376 343.228,311.376L383.228,311.376C385.988,311.376 388.228,309.136 388.228,306.376L388.228,286.376",
    style: {
      fill: "none",
      stroke: "rgb(38,166,154)",
      strokeWidth: "4.02px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-336.228,-249.021)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00594,2.79205e-16,2.79196e-16,1.00591,337.694,246.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.853,37.147L51.706,12.294",
    style: {
      fill: "none",
      stroke: "rgb(38,166,154)",
      strokeWidth: "3.98px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-336.228,-249.021)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.502955,0,0,0.5,363.701,252.353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.707,12.294L26.853,12.294",
    style: {
      fill: "none",
      stroke: "rgb(38,166,154)",
      strokeWidth: "7.98px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-336.228,-249.021)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-5.39139e-16,-0.502987,0.502987,-5.39139e-16,383.818,284.507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.707,12.294L26.853,12.294",
    style: {
      fill: "none",
      stroke: "rgb(38,166,154)",
      strokeWidth: "7.95px"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportarrow3);
export default __webpack_public_path__ + "static/media/exportarrow3.52393d8eba0e33c2f6dc22c3edee3501.svg";
export { ForwardRef as ReactComponent };